<template>
    <div :class="'custom-popup-modal mx ' + (vg_pdfModal ? 'active' : '')">
        <div class="custom-modal-wrapper height-auto">
            <div class="customer-model-content add-new-product-model text-white">
                <button class="close-btn" @click.prevent="closeModal()">X</button>
                <h5>{{ vg_pdfModalObj.product_model + ' - ' + vg_pdfModalObj.serial_number }}</h5>
                <embed width="100%" height="500px" v-if="pdfdata" :src="pdfdata" class="embed-pdf" />
            </div>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import {mapGetters, mapActions} from 'vuex';

export default {
    name: 'CustomPDfModal',
    data() {
        return {
            pdfdata: ''
        };
    },
    computed: {
        ...mapGetters({
            vg_pdfModal: 'pdf/active',
            vg_pdfModalObj: 'pdf/activeObj',
            vg_user: 'auth/user'
        })
    },
    watch: {
        vg_pdfModalObj: function (data) {
            if (this.vg_pdfModal && data.target_key == 'coc_certificate') {
                this.viewWarantee(this.vg_pdfModalObj.id);
            } else if (this.vg_pdfModal && data.target_key == 'proof_of_purchase') {
                this.viewProofOfPurchase(this.vg_pdfModalObj.id);
            }
        }
    },
    mounted() {
        this.closeModal();
    },
    methods: {
        viewWarantee(id) {
            this.pdfdata = '';
            const url = `${Env.baseUrl}/v2/resource/check-coc-certificate`;
            AuthApis.postApi(url, {
                pid: id
            })
                .then((res) => {
                    this.pdfdata = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        viewProofOfPurchase(id) {
            this.pdfdata = '';
            const url = `${Env.baseUrl}/v2/resource/check-proof-of-purchase`;
            AuthApis.postApi(url, {
                pid: id
            })
                .then((res) => {
                    this.pdfdata = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        closeModal() {
            this.pdfdata = '';
            this.va_modal(false);
            this.va_modalObj({});
        },

        ...mapActions({
            va_modal: 'pdf/setActive',
            va_modalObj: 'pdf/setActiveObj'
        })
    }
};
</script>
